import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token when present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lb_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Build a public image URL from a stored storage path
export const fileUrl = (path) => (path ? `${API}/files/${path}` : "");

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
